import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_32: FaireProductEntity = {
  token: "catalog_prod_prod-32",
  type: "product",
  name: "Figurine",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  priceDollars: 107.58,
  msrpDollars: 268.95,
  sku: "PA0032",
  caseSize: 4,
  material: "Linen",
  collectionToken: "col_pattern-play",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: true,
  inStock: false,
  stockLevel: 31,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_home-accents"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
